import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SelectOptionDialog } from './select-option.dialog';

@Injectable({
  providedIn: 'root'
})
export class SelectOpionServiceDialog {

    constructor(public dialog: MatDialog) {}

    public open(feature: string, current: string, options: string[], callback: any) {
 
        let dialog = this.dialog.open(SelectOptionDialog, {
            width: "99%",
            maxWidth: "99%",

            autoFocus: false,
            data: {
                feature,
                options,
                current
            }
        });

        dialog.afterClosed().subscribe(r => {
            callback(r);
        })
    }
}
